import React, { Suspense } from 'react'
import * as propTypes from 'prop-types'
import apiConfig from '../../apiConfig'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import {
  Grid,
  Input,
  Popover,
  Drawer,
  Button,
  Chip,
  Badge,
  Form,
  Card,
} from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, {
  SearchIcon,
  CancelIcon,
  ChevronRightIcon,
} from '@enterprise-ui/icons'
import copy from 'copy-to-clipboard'
import withHOCs from 'util/withHocs'
import { isEmpty, isEqual, cloneDeep } from 'lodash'
import {
  fetchPropsMetadata,
  fetchScenicMetadata,
} from '../../services/inventoryService'
import ReactSelect from 'react-select'
import { PROPS, SCENIC } from 'enums/Tabs'
import { getFormattedOptions } from '../../util/CommonUtils'

import DialogBox from '../../components/DialogBox/DialogBox'

import NameFiltersPopUp from './NameFiltersPopUp'
import { fetchAllScenicRooms } from '../../services/scenicRoomService'

import {
  getBuildings,
  getCheckInLocation,
  getLLBuildingByLocation,
} from '../../services/locationService'
import { locationResponseToSelect } from '../../mappers/locationMapper'
import { getAllProjects } from '../../services/projectsService'
import { projectNamesResponse } from '../../mappers/projectMapper'
import { getAllCollections } from '../../services/collectionsService'
import { getAllBrands, getAllUsers } from '../../services/inventoryService'
import {
  getAllDepartments,
  getClassByDepartment,
} from '../../services/itemService'

import { collectionNamesResponse } from '../../mappers/collectionMapper'
import {
  brandNamesResponseToSelect,
  userNamesResponseToSelect,
  departmentResponseToSelect,
  departmentClassResponseToSelect,
  getFormattedSubCategories,
} from '../../mappers/inventoryMapper'

import {
  getFilters,
  saveFilters,
  setFilters,
  deleteFilters,
  saveFilterData,
} from '../../store/filters/actionCreator'
import { getProjectChannel } from '../../store/newShootType/actionCreator'
import { fetchLocationDetails } from '../../store/searchInventory/actionCreator'
import {
  selectPageAvailableFilters,
  selectPageFilters,
  getStoreChannels,
  getLocationDetails,
} from '../../store/filters/selectors'
import { getUserName, DATE_FORMAT } from '../../util/CommonUtils'
import { SEARCH_LOCATIONS_COMPONENT_TYPE } from '../../enums/locations'
import {
  regexExpressions,
  autocompleteSelectData,
  deptClassInputs,
  locationLevelsInputs,
  listInputs,
  dateInputs,
  nameBasedListInputs,
  booleanInputs,
  filtersFromParamsSearch,
  paramsFromFilters,
} from './constants'
import { filterLocations } from '../../store/manageLocations/actionCreator'
import { getDropdownData } from '../../store/searchInventory/actionCreator'
import { scenicRoomResponse } from '../../mappers/scenicRoomMapper'
import { DatePicker } from '@enterprise-ui/canvas-ui-react-datepicker'

const OtherComponent = React.lazy(() => {
  return new Promise((resolve) => setTimeout(resolve, 3000)).then(
    () => import('../../components/LocationDropdowns')
  )
})

const styles = (theme) => ({
  root: {
    overflowX: 'visible',
  },

  chipFilterTextField: {
    width: '100%',
  },

  chipRoot: {
    margin: '2px',
    minHeight: '26px',
    height: 'auto',
  },
  chipArrayLabel: {
    whiteSpace: 'pre-wrap',
  },

  dateInput: {
    fontSize: '14.5px',
  },

  toolBar: {
    position: 'absolute',
    left: '1059px',
    width: '37%',
    top: '169px',
  },
  filterTitle: {
    paddingLeft: '25px',
    width: '300px',
  },
  spacer: {
    flex: '1 1 auto',
  },
  getFilterClearName: {
    fontSize: '17px',
    marginTop: '12px',
    marginLeft: '10px',
  },
  getFilterClear: {
    margin: '12px 7px 0 0',
    cursor: 'pointer',
  },
  autocompleteStyle: {
    width: '20vw',
    paddingBottom: '10px',
    marginTop: '5px',
  },
})

class AddFiltersCanvas extends React.PureComponent {
  constructor(props) {
    super(props)
    const { selectableFilters = [], filters = {} } = this.props
    const filtersCopy = Object.assign({}, filters)
    this.anchorRef = React.createRef()
    this.selectRef = React.createRef()
    this.state = {
      inputTypeFilters: {
        exclude_filters: { filterSelect: '' },
        include_filters: { filterSelect: '' },
        include_filters: { filterSelect: '' },
        save_filters: { filterSelect: '' },
      },
      popOverOpen: '',
      moreFiltersDialog: false,
      selectIsOpen: false,
      selectableFilters: selectableFilters,
      filters: filtersCopy,
      saveFiltersPopUpIsVisible: false,
      openFiltersPopUpIsVisible: false,
      autocompleteSelectData: autocompleteSelectData,
      sortParam: '',
      sortOrder: '',
      handleDropDownTrigger: false,
      handleTriggerProps: {},
      resetLocations: false,
      locationsLabel: [],
      isFetchedlocation: false,
      selectedFilter: false,
      filterTitle: '',
      filterId: '',
      showAlertOnDelete: false,
      alertMessageOnDelete: '',
      deleteFilterId: '',
      deleteResponse: false,
    }
    this.autoC = React.createRef(null)
    const {
      auth: {
        session: { userInfo = {} },
      },
    } = this.props
    this.userProfilename = getUserName(userInfo)
  }

  componentDidMount() {
    const { filters: stateFilters = {} } = this.state
    let filtersCopy = Object.assign({}, stateFilters)
    const {
      setFiltersUpdated = () => {},
      getProjectChannel = () => {},
      locations = [],
    } = this.props
    if (!isEmpty(locations)) {
      this.setState({ locationsLabel: locations })
    }
    this.openSavedFilters()
    getProjectChannel()
    setFiltersUpdated(true, filtersCopy)
  }

  componentDidUpdate(prevProps = {}, prevState = {}) {
    const {
      isQuickFilterUpdated: stateIsFilterUpdated,
      locations: stateLocations = [],
      mergedFilters = {},
      setFiltersUpdated = () => {},
    } = this.props
    const {
      isQuickFilterUpdated: prevStateIsFilterUpdated,
      mergedFilters: prevMergedFilters = {},
    } = prevProps
    const { quickFilters = {}, pageName = '', channels = [] } = this.props
    const {
      autocompleteSelectData: autocompleteSelectDataCopy = {},
      locationsLabel: stateLocationsLabel = [],
      isFetchedlocation,
      filters: stateFilters = {},
    } = this.state
    if (
      Object.entries(mergedFilters).length > 0 &&
      !isEqual(mergedFilters, prevMergedFilters)
    ) {
      this.setState({
        filters: Object.assign({}, stateFilters, mergedFilters),
      })
    }
    const filtersCopy = Object.assign({}, quickFilters)
    if (
      !!stateIsFilterUpdated &&
      stateIsFilterUpdated !== prevStateIsFilterUpdated
    ) {
      this.setState({
        filters: filtersCopy,
      })
    }
    if (
      !!stateLocations &&
      stateLocations !== stateLocationsLabel &&
      !!isFetchedlocation
    ) {
      this.setState({
        locationsLabel: stateLocations,
        isFetchedlocation: false,
      })
    }
    if (
      channels.length > 0 &&
      prevProps.channels !== channels &&
      ['searchInventory', 'myOrders'].indexOf(pageName) !== -1
    ) {
      const ChannelList = this.getFormattedChannels(channels)
      const newAutoCompleteData = Object.assign(
        {},
        autocompleteSelectDataCopy,
        { 'Project Channel': ChannelList, 'Shipment Channel': ChannelList }
      )
      this.setState({
        autocompleteSelectData: newAutoCompleteData,
      })
    }
    if (this.state.savedData) {
      setFiltersUpdated(true, this.state.filters, this.state.savedData)
      this.setState({
        savedData: false,
      })
    }
  }

  getFormattedChannels = (channels = []) => {
    const channelsCopy = [...channels]
    const ChannelList = channelsCopy.map((it) =>
      Object.assign(
        {},
        {
          value: it.channel,
          label: it.channel,
        }
      )
    )
    return ChannelList.sort((a, b) => (a.name > b.name ? -1 : 1))
  }

  getSelectableFilters = () => {
    const { filters = {} } = this.state
    let { selectableFilters = [] } = this.state
    const selectableFiltersCopy = [...selectableFilters]
    const returnArray = selectableFiltersCopy.filter(function (el) {
      if (el) {
        return !listInputs.includes(el)
      }
    })
    return returnArray || []
  }
  getListInputSelectableFilters = () => {
    let { selectableFilters = [] } = this.state
    const selectableFiltersCopy = [...selectableFilters]
    const returnArray = selectableFiltersCopy.filter(function (el) {
      return listInputs.includes(el)
    })
    return returnArray || []
  }
  openSavedFilters = () => {
    const { getFilters = () => {}, pageName = '' } = this.props
    let additionalParams = {
      feature: 'search_include_filters',
    }
    getFilters(pageName, additionalParams)
  }

  showSaveFiltersPopUp = (event) => {
    event.preventDefault()
    this.setState({
      saveFiltersPopUpIsVisible: true,
    })
  }

  fetchAutocompleteData = (filter, currentDeptValue = '') => {
    if (['Location', 'Shipment Ship To'].indexOf(filter) !== -1) {
      let otherLocations = getBuildings().then((data) => {
        return locationResponseToSelect(data)
      })
      let defaultLocations = getLLBuildingByLocation('generic').then((data) => {
        return locationResponseToSelect(data)
      })
      return Promise.all([otherLocations, defaultLocations]).then(
        function (values) {
          return values.flat().sort((a, b) => {
            const One = a.label.toUpperCase()
            const Two = b.label.toUpperCase()
            return One < Two ? -1 : One > Two ? 1 : 0
          })
        }
      )
    } else if (
      ['Ship To Location', 'Shipment Ship From'].indexOf(filter) !== -1
    ) {
      return getCheckInLocation().then((data) => {
        return locationResponseToSelect(data)
      })
    } else if (filter === 'Project/Collection Name') {
      let currentProjectNames = getAllProjects().then((res) => {
        return projectNamesResponse(res)
      })
      let currentCollectionNames = getAllCollections().then((res) => {
        return collectionNamesResponse(res)
      })
      return Promise.all([currentProjectNames, currentCollectionNames]).then(
        function (values) {
          return values
            .flat()
            .filter((it) => it)
            .sort((a, b) =>
              a.label < b.label ? -1 : a.label > b.label ? 1 : 0
            )
        }
      )
    } else if (filter === 'Projects-Current') {
      let params = { status: 'PENDING' }
      let currentProjectNames = getAllProjects(params).then((res) => {
        return projectNamesResponse(res)
      })
      return currentProjectNames
    } else if (filter === 'Projects-Completed') {
      let params = { status: 'COMPLETED' }
      let completedProjectNames = getAllProjects(params).then((res) => {
        return projectNamesResponse(res)
      })
      return completedProjectNames
    } else if (filter === 'Collections-Current') {
      let params = { status: '' }
      let currentCollectionNames = getAllCollections(params).then((res) => {
        return collectionNamesResponse(res)
      })
      return currentCollectionNames
    } else if (filter === 'Collections-Completed') {
      let params = { status: 'COMPLETED' }
      let completedCollectionNames = getAllCollections(params).then((res) => {
        return collectionNamesResponse(res)
      })
      return completedCollectionNames
    } else if (filter === 'Collections-Cancelled') {
      let params = { status: 'CANCELLED' }
      let cancelledCollectionNames = getAllCollections(params).then((res) => {
        return collectionNamesResponse(res)
      })
      return cancelledCollectionNames
    } else if (filter === 'Brand' || filter === 'Scenic Brand') {
      return getAllBrands().then((data) => {
        return brandNamesResponseToSelect(data)
      })
    } else if (filter === 'Scenic Room') {
      let scenicRooms = fetchAllScenicRooms({}).then((res) => {
        return scenicRoomResponse(res)
      })
      return scenicRooms
    } else if (
      [
        'Ordered By',
        'Shipment Creator',
        'ordered_by',
        'Props Specialist',
        'Scenic Created By',
      ].indexOf(filter) !== -1
    ) {
      return getAllUsers().then((data) => {
        return userNamesResponseToSelect(data)
      })
    } else if (filter === 'Dept-Class' && currentDeptValue === '') {
      return getAllDepartments(currentDeptValue).then((data) => {
        return departmentResponseToSelect(data)
      })
    } else if (filter === 'Dept-Class' && currentDeptValue !== '') {
      return getClassByDepartment(currentDeptValue).then((data) => {
        return departmentClassResponseToSelect(data)
      })
    } else if (filter === 'Props Color') {
      return fetchPropsMetadata().then((res) => {
        const { data = {} } = res
        const { colorFamily = [] } = data
        return getFormattedOptions(
          colorFamily,
          {
            value: 'color_id',
            label: 'name',
          },
          true
        )
      })
    } else if (
      filter === 'Props Category- Sub Category' &&
      currentDeptValue === ''
    ) {
      return fetchPropsMetadata().then((res) => {
        const { data = {} } = res
        const { categories = [] } = data
        return getFormattedOptions(
          categories,
          {
            value: 'category_id',
            label: 'name',
          },
          true
        )
      })
    } else if (
      filter === 'Props Category- Sub Category' &&
      currentDeptValue !== ''
    ) {
      return fetchPropsMetadata().then((res) => {
        const { data = {} } = res
        const { categories = [] } = data
        return getFormattedSubCategories(categories, currentDeptValue)
      })
    } else if (
      filter === 'Scenic Category - Sub Category' &&
      currentDeptValue === ''
    ) {
      return fetchScenicMetadata().then((res) => {
        const { data = {} } = res
        const { categories = [] } = data
        return getFormattedOptions(
          categories,
          {
            value: 'category_id',
            label: 'name',
          },
          true
        )
      })
    } else if (
      filter === 'Scenic Category - Sub Category' &&
      currentDeptValue !== ''
    ) {
      return fetchScenicMetadata().then((res) => {
        const { data = {} } = res
        const { categories = [] } = data
        return getFormattedSubCategories(categories, currentDeptValue)
      })
    } else if (filter === 'Scenic Source') {
      return fetchScenicMetadata().then((res) => {
        const { data = {} } = res
        const { sources = [] } = data
        return getFormattedOptions(
          sources,
          {
            value: 'source_id',
            label: 'source_name',
          },
          true
        )
      })
    } else if (filter === 'Props Material') {
      return fetchPropsMetadata().then((res) => {
        const { data = {} } = res
        const { materials = [] } = data
        return getFormattedOptions(
          materials,
          {
            value: 'material_id',
            label: 'material_name',
          },
          true
        )
      })
    }
  }

  setFiltersData = (filters) => {
    const formattedFilters = filtersFromParamsSearch(filters)
    this.setState({
      filters: formattedFilters,
    })
  }

  setFilters = (filters) => {
    this.setState({
      filters: filters,
    })
  }

  closeWithoutSaving = () => {
    this.setState({
      saveFiltersPopUpIsVisible: false,
    })
  }

  closeWithoutChoosing = () => {
    this.setState({
      openFiltersPopUpIsVisible: false,
    })
  }
  handleChooseFilters = (filterTitle = '') => {
    const formattedFilters = filtersFromParamsSearch(cloneDeep(filterTitle))
    this.setState({
      openFiltersPopUpIsVisible: false,
      filters: formattedFilters,
      savedData: true,
    })
  }

  handleSaveFilters = (title = '', checkBoxSelected = false) => {
    const {
      saveFilters = () => {},
      auth: {
        session: { userInfo: { lanId = '' } = {} },
      },
      filterCompType = '',
      pageName = '',
    } = this.props
    const { filterId = '' } = this.state
    const { filters: stateFilters = {} } = this.state
    const filtersCopy = Object.assign({}, stateFilters)
    const compBasedFilters = filtersCopy[filterCompType] || {}
    const filtersList = Object.keys(compBasedFilters)
    const filterData = paramsFromFilters(
      filtersCopy,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      true,
      this.props.currentTabValue
    )
    const { requestPayload = {} } = filterData
    const filterRequest = {
      lanId: lanId,
      title: title,
      filters: filtersList,
      accessType: false,
      id: !checkBoxSelected ? filterId : '',
      feature: 'search_include_filters',
    }
    const filtersCopySave = {
      title: title,
      data: requestPayload,
    }
    saveFilters(filterRequest, filtersCopySave, pageName)
    this.setState({
      saveFiltersPopUpIsVisible: false,
    })
    this.openSavedFilters()
  }

  clearFilters = () => {
    const { setFiltersUpdated = () => {}, fromSearch = false } = this.props
    const { filters = {} } = this.state
    const stateFiltersCopy = Object.assign({}, filters)
    const filtersCopy = Object.assign({}, stateFiltersCopy, {
      exclude_filters: {},
      include_filters: {},
      savedData: false,
    })
    this.openSavedFilters()
    const ele =
      fromSearch &&
      this.autoC.current.getElementsByClassName(
        'MuiAutocomplete-clearIndicator'
      )[0]
    if (ele) ele.click()
    this.setState(
      {
        filters: filtersCopy,
        openFiltersPopUpIsVisible: false,
        filterTitle: '',
        filterId: '',
      },
      () => {
        setFiltersUpdated(true, filtersCopy)
      }
    )
  }

  handleTriggerCallback = () => {
    this.setState({
      handleDropDownTrigger: false,
      handleTriggerProps: {},
    })
  }

  searchLocationByID = (filter = '', locationId = '') => {
    const loctionIdString = locationId.split(/[,\r\n\s]+/g).join(',')
    const { filterCompType = '' } = this.props
    // this.currentUserLocations(loctionIdString)
    const { filters: stateFilters = {} } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter].textFieldValue = loctionIdString
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
  }

  currentUserLocations = async (locationId = '') => {
    const { filterLocations, userLocation = '' } = this.props
    let params = new URLSearchParams()
    params.append('key', apiConfig.apiKey)

    if (!isEmpty(locationId)) {
      params.append('location_ids', locationId)
    } else {
      params.append('building', userLocation)
    }
    await filterLocations(params)
  }

  removeFilter = (filter) => {
    const { filters: stateFilters = {} } = this.state
    let filtersCopy = cloneDeep(stateFilters)
    const { setFiltersUpdated = () => {}, filterCompType = '' } = this.props
    delete filtersCopy[filterCompType][filter]
    const { sortParam = '', sortOrder = '' } = this.state
    let { sortParamCopy = '', sortOrderCopy = '' } = { sortParam, sortOrder }
    if (sortParam === filter.split(' ').join('_')) {
      sortParamCopy = ''
      sortOrderCopy = ''
    }
    this.setState({
      filters: filtersCopy,
      sortParam: sortParamCopy,
      sortOrder: sortOrderCopy,
    })
    setFiltersUpdated(true, filtersCopy, sortParamCopy, sortOrderCopy)
  }

  getChipArray = (chipArray = [], selectData = []) => {
    let returnArray = chipArray.map((chipArrayInstance, i) => {
      let tempArray = selectData.find(
        (selectDataInstance) =>
          selectDataInstance.value.toString() ===
          chipArrayInstance.value.toString()
      )

      return tempArray
    })
    return returnArray
  }
  getHelperText = (filter, textFieldValue) => {
    const sampleCount = !isEmpty(textFieldValue)
      ? (textFieldValue.trim(), textFieldValue.split(/[,\r\n\s]+/g).length)
      : ''
    switch (filter) {
      case 'TCIN':
        return sampleCount ? `${sampleCount} TCIN(s)` : ''
      case 'DPCI':
        return sampleCount ? `${sampleCount} DPCI(s)` : ''
      case 'Pegasus ID':
        return sampleCount ? `${sampleCount} Pegasus ID(s)` : ''
      case 'Barcode Number':
        return sampleCount ? `${sampleCount} Barcode Number(s)` : ''
      default:
        return ''
    }
  }
  getAllFilterChips = () => {
    const { filterCompType = '' } = this.props
    const {
      filters: stateFilters = [],
      locationsLabel = [],
      popOverOpen = '',
    } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    let returnStr = null
    let filteredKeys = Object.keys(filtersCopy).filter(
      (key) => filtersCopy[key] && filtersCopy[key]?.chipArray?.length > 0
    )
    const { deptChipArray = [], deptClassChipArray = [] } =
      filtersCopy['Dept-Class'] || {}
    if (
      (filteredKeys && filteredKeys.length > 0) ||
      (deptChipArray && deptChipArray.length > 0) ||
      (deptClassChipArray && deptClassChipArray.length > 0)
    ) {
      returnStr = []
      filteredKeys.forEach((dat) => {
        const currentFilterData = filtersCopy[dat] || {}
        const { chipArray = [] } = currentFilterData

        returnStr.push(
          <Popover
            size="expanded"
            type="clickOnly"
            location="bottom"
            content={
              <div style={{ zIndex: '99' }}>
                <Grid.Container>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-header"
                  >
                    <span>{`${filterCompType === 'exclude_filters' ? 'Excluded' : 'Added '} ${dat}s`}</span>
                  </Grid.Item>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-body"
                  >
                    {chipArray.map(
                      (data, index) =>
                        data && (
                          <Chip
                            removable
                            onRequestDelete={(e) => {
                              e.stopPropagation()
                              this.handleDeleteChip(
                                dat,
                                data,
                                index,
                                'chipArray'
                              )()
                            }}
                            className="chip-root chip-array-label"
                          >
                            {data.label || data}
                          </Chip>
                        )
                    )}
                  </Grid.Item>
                  {listInputs.includes(dat) ? (
                    <Grid.Item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="poper-footer"
                    >
                      <Button
                        type="primary"
                        onClick={() => {
                          copy(
                            chipArray
                              .map((item) => item.value || item)
                              .join(','),
                            {
                              format: 'text/plain',
                            }
                          )
                        }}
                      >
                        Copy
                      </Button>
                    </Grid.Item>
                  ) : (
                    <Grid.Item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="poper-footer"
                    >
                      <Button
                        type="primary"
                        onClick={() => {
                          this.setState({ moreFiltersSelectedDialog: dat })
                        }}
                      >
                        Add {dat}
                      </Button>
                    </Grid.Item>
                  )}
                </Grid.Container>
              </div>
            }
          >
            <Chip
              removable
              onRequestDelete={this.handleDeleteChip(
                dat,
                '',
                '',
                'chipArray',
                'all'
              )}
              className="chip-root chip-array-label"
            >
              {dat} <Badge location="inline" content={chipArray.length} />
            </Chip>
          </Popover>
        )
      })

      // Dept chips
      if (deptChipArray && deptChipArray.length > 0) {
        returnStr.push(
          <Popover
            size="expanded"
            type="clickOnly"
            location="bottom"
            content={
              <div style={{ zIndex: '9999999999' }}>
                <Grid.Container>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-header"
                  >
                    <span>{`${filterCompType === 'exclude_filters' ? 'Excluded' : 'Added '} Departments`}</span>
                  </Grid.Item>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-body"
                  >
                    {deptChipArray.map(
                      (data, index) =>
                        data && (
                          <Chip
                            removable
                            onRequestDelete={(e) => {
                              e.stopPropagation()
                              this.handleDeleteChip(
                                'Dept-Class',
                                data,
                                index,
                                'deptChipArray'
                              )()
                            }}
                            className="chip-root chip-array-label"
                          >
                            {data.label || data}
                          </Chip>
                        )
                    )}
                  </Grid.Item>

                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-footer"
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        this.setState({
                          moreFiltersSelectedDialog: 'Dept-Class',
                        })
                      }}
                    >
                      Add Departments
                    </Button>
                  </Grid.Item>
                </Grid.Container>
              </div>
            }
          >
            <Chip
              removable
              onRequestDelete={this.handleDeleteChip(
                'Dept-Class',
                '',
                '',
                'deptChipArray',
                'all'
              )}
              className="chip-root chip-array-label"
            >
              Departments{' '}
              <Badge location="inline" content={deptChipArray.length} />
            </Chip>
          </Popover>
        )
      }

      // Dept-Class chips
      if (deptClassChipArray && deptClassChipArray.length > 0) {
        returnStr.push(
          <Popover
            size="expanded"
            type="clickOnly"
            location="bottom"
            content={
              <div style={{ zIndex: '9999999999' }}>
                <Grid.Container>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-header"
                  >
                    <span>{`${filterCompType === 'exclude_filters' ? 'Excluded' : 'Added '} Department-Class`}</span>
                  </Grid.Item>
                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-body"
                  >
                    {deptClassChipArray.map(
                      (data, index) =>
                        data && (
                          <Chip
                            removable
                            onRequestDelete={(e) => {
                              e.stopPropagation()
                              this.handleDeleteChip(
                                'Dept-Class',
                                data,
                                index,
                                'deptClassChipArray'
                              )()
                            }}
                            className="chip-root chip-array-label"
                          >
                            {data.label || data}
                          </Chip>
                        )
                    )}
                  </Grid.Item>

                  <Grid.Item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className="poper-footer"
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        this.setState({
                          moreFiltersSelectedDialog: 'Dept-Class',
                        })
                      }}
                    >
                      Add Departments
                    </Button>
                  </Grid.Item>
                </Grid.Container>
              </div>
            }
          >
            <Chip
              removable
              onRequestDelete={this.handleDeleteChip(
                'Dept-Class',
                '',
                '',
                'deptClassChipArray',
                'all'
              )}
              className="chip-root chip-array-label"
            >
              Department-Class{' '}
              <Badge location="inline" content={deptClassChipArray.length} />
            </Chip>
          </Popover>
        )
      }

      // Clear all button
      returnStr.push(
        <Button
          key="clear-all-chips"
          type="ghost"
          className="clear-all-button"
          id="clearall"
          size="small"
          onClick={() => {
            this.handleAllDeleteChip()
          }}
        >
          <EnterpriseIcon icon={CancelIcon} /> CLEAR ALL
        </Button>
      )
    }
    return returnStr
  }
  getBundled = (e, value, filter) => {
    const { filterCompType = '', setFiltersUpdated = () => {} } = this.props
    const { filters: stateFilters = {} } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter] = value
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
    setFiltersUpdated(true, updateStateFilters, '', '')
  }
  getInputMethod = (filter = '') => {
    function MultiValue(props = {}) {
      const {
        selectProps: { classes = {} },
      } = props
      return (
        <Chip
          removable
          onRequestDelete={props.removeProps.onClick}
          className="chip-root"
        >
          {props.children}
        </Chip>
      )
    }

    const {
      filters: currentFilters = {},
      autocompleteSelectData: autocompleteSelectDataCopy = {},
      sortParam: stateSortParam = '',
      sortOrder: stateSortOrder = '',
      handleDropDownTrigger,
      handleTriggerProps,
    } = this.state
    const {
      classes = {},
      setFiltersUpdated = () => {},
      filterCompType = '',
      pageName = '',
    } = this.props
    const filtersCopy = Object.assign({}, currentFilters)
    const stateFilters = Object.assign({}, filtersCopy[filterCompType])
    const stateFiltersList = Object.keys(stateFilters)
    const isFilterExistsInState =
      stateFiltersList.length > 0 && stateFiltersList.indexOf(filter) !== -1
    const currentFilterList = isFilterExistsInState ? stateFilters[filter] : {}
    if (dateInputs.includes(filter)) {
      const { startDate: currFilterStartDate, endDate: currFilterEndDate } =
        currentFilterList
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Input.Label style={{ fontWeight: 600 }}>{filter}</Input.Label>
          <DatePicker
            id="startDate"
            autoOk
            className="date-picker-filter"
            type="gregorian"
            label=""
            placeholder={'Start Date'}
            value={currFilterStartDate || null}
            format="YYYY/MM/DD"
            onUpdate={(id, val) => {
              this.handleDateInput(filter, val, 'startDate')
            }}
            error={currFilterStartDate > currFilterEndDate}
            errorText={"Can't select a date after the end date"}
          />
          <p className="helper-text" style={{ marginBottom: '5px' }}>
            Set a range by selecting a second date:
          </p>
          <DatePicker
            id="endDate"
            autoOk
            className="date-picker-filter"
            type="gregorian"
            label=""
            placeholder={'End Date'}
            value={currFilterEndDate || null}
            format="YYYY/MM/DD"
            disableDates={{
              before: currFilterStartDate,
            }}
            onUpdate={(id, val) => {
              this.handleDateInput(filter, val, 'endDate')
            }}
            error={currFilterEndDate < currFilterStartDate}
            errorText="Can't select a date before the start date"
          />
          <Button
            style={{ alignSelf: 'end' }}
            id="apply"
            className="apply-btn-margin secondary-btn"
            type="secondary"
            onClick={() => {
              const updateStateFilters = Object.assign({}, filtersCopy, {
                [filterCompType]: stateFilters,
              })
              setFiltersUpdated(
                true,
                updateStateFilters,
                stateSortParam,
                stateSortOrder
              )
            }}
            disabled={!currFilterStartDate}
          >
            APPLY
          </Button>
        </div>
      )
    } else if (deptClassInputs.includes(filter)) {
      const {
        currentDeptValue = '',
        currentClassValue = '',
        deptChipArray = [],
        categorySubCategoryArray = [],
        deptClassChipArray = [],
        selectData: currFilterSelectData = [],
        classSelectData = [],
        currentCategoryValue = '',
        currentSubCategoryValue = '',
        categoryChipArray = [],
        scenicCategorySubCategoryArray = [],
        scenicCategoryChipArray = [],
      } = currentFilterList
      let localCategoryArray =
        this.props.currentTabValue !== SCENIC
          ? categoryChipArray
          : scenicCategoryChipArray
      let localCategorySubCategoryArray =
        this.props.currentTabValue !== SCENIC
          ? categorySubCategoryArray
          : scenicCategorySubCategoryArray
      if (
        !isEmpty(autocompleteSelectDataCopy[filter]) &&
        isEmpty(currFilterSelectData)
      ) {
        let stateFiltersCopy = cloneDeep(stateFilters)
        stateFiltersCopy[filter].selectData = autocompleteSelectDataCopy[filter]
        const updateStateFilters = Object.assign({}, currentFilters, {
          [filterCompType]: stateFiltersCopy,
        })
        this.setState({ filters: updateStateFilters })
      } else if (isEmpty(currFilterSelectData)) {
        this.fetchAutocompleteData(filter, currentDeptValue).then(
          (selectData) => {
            const stateFiltersCopy = cloneDeep(stateFilters)
            stateFiltersCopy[filter].selectData = selectData
            const updateStateFilters = Object.assign({}, currentFilters, {
              [filterCompType]: stateFiltersCopy,
            })
            this.setState({ filters: updateStateFilters })
          }
        )
      }
      if (
        currentDeptValue !== '' &&
        isEmpty(classSelectData) &&
        currentClassValue === ''
      ) {
        this.fetchAutocompleteData(filter, currentDeptValue).then(
          (selectData) => {
            const stateFiltersCopy = Object.assign({}, stateFilters)
            stateFiltersCopy[filter].classSelectData = selectData
            const updateStateFilters = Object.assign({}, currentFilters, {
              [filterCompType]: stateFiltersCopy,
            })
            this.setState({ filters: updateStateFilters })
          }
        )
      } else if (currentCategoryValue !== '' && isEmpty(classSelectData)) {
        this.fetchAutocompleteData(filter, currentCategoryValue).then(
          (selectData) => {
            const stateFiltersCopy = Object.assign({}, stateFilters)
            stateFiltersCopy[filter].classSelectData = selectData
            const updateStateFilters = Object.assign({}, currentFilters, {
              [filterCompType]: stateFiltersCopy,
            })
            this.setState({ filters: updateStateFilters })
          }
        )
      }
      const components = { MultiValue }
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Input.Label style={{ fontWeight: 600 }}>{filter}</Input.Label>
          <div>
            <ReactSelect
              classes={classes}
              styles={{
                input: (base) => ({
                  ...base,
                  height: '48px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }),
              }}
              inputId="react-select-dept"
              TextFieldProps={{
                label:
                  (filterCompType === 'exclude_filters' ? 'Exclude' : 'Add ') +
                  filter,
                InputLabelProps: {
                  htmlFor: 'react-select-dept',
                  shrink: true,
                },
              }}
              placeholder={
                filter === 'Dept-Class' ? 'Select Dept' : 'Select Category'
              }
              options={currFilterSelectData}
              onChange={(event) =>
                this.handleDepartmentChange(filter, event.value)
              }
              components={components}
            />
          </div>
          <div>
            <ReactSelect
              classes={classes}
              ref={this.selectRef}
              styles={{
                input: (base) => ({
                  ...base,
                  height: '50px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }),
              }}
              inputId="react-select-dept-class"
              TextFieldProps={{
                label:
                  (filterCompType === 'exclude_filters' ? 'Exclude' : 'Add ') +
                  filter,
                InputLabelProps: {
                  htmlFor: 'react-select-dept-class',
                  shrink: true,
                },
              }}
              placeholder={
                filter === 'Dept-Class' ? 'Select Class' : 'Select Sub Category'
              }
              options={classSelectData}
              onChange={(value) => this.handleClassChange(filter, value)}
              isMulti
              components={components}
              isDisabled={
                filter === 'Dept-Class'
                  ? !currentDeptValue
                  : !currentCategoryValue
              }
            />
          </div>

          <div className="apply-button-parent">
            <Button
              id="addDeptClass"
              className={
                currentSubCategoryValue
                  ? 'add-cat-sub-cat-button'
                  : 'add-dept-class-button'
              }
              onClick={() => {
                this.processDeptClassChips(
                  filter === 'Dept-Class'
                    ? currentDeptValue
                    : currentCategoryValue,
                  filter === 'Dept-Class'
                    ? currentClassValue
                    : currentSubCategoryValue,
                  filter
                )
              }}
              disabled={
                filter === 'Dept-Class'
                  ? !currentDeptValue
                  : !currentCategoryValue
              }
            >
              {filter === 'Dept-Class'
                ? currentClassValue
                  ? 'ADD DEPARTMENT-CLASS'
                  : 'ADD DEPARTMENT'
                : currentSubCategoryValue
                  ? 'ADD CATEGORY-SUB-CATEGORY'
                  : 'ADD CATEGORY'}
            </Button>
          </div>
          <div>
            {!isEmpty(localCategoryArray) ? <span>Category: </span> : null}
            {localCategoryArray.map((data, index) => {
              return (
                <Chip
                  removable
                  onRequestDelete={this.handleDeleteChip(
                    filter,
                    data,
                    index,
                    'categoryChipArray'
                  )}
                  className="chip-root"
                >
                  {data}
                </Chip>
              )
            })}
          </div>
          <div>
            {!isEmpty(localCategorySubCategoryArray) ? (
              <span>Category - Sub Category: </span>
            ) : null}
            {localCategorySubCategoryArray.map((data, index) => {
              return (
                <Chip
                  removable
                  onRequestDelete={this.handleDeleteChip(
                    filter,
                    data,
                    index,
                    'categorySubCategoryArray'
                  )}
                  className="chip-root"
                >
                  {data}
                </Chip>
              )
            })}
          </div>
        </div>
      )
    } else if (locationLevelsInputs.includes(filter)) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Input.Label style={{ fontWeight: 600 }}>{filter}</Input.Label>
          <Suspense fallback={<div>loading...</div>}>
            <OtherComponent
              isModalOpen={true}
              resetLocations={false}
              setIsNewOption={() => {}}
              componentType={SEARCH_LOCATIONS_COMPONENT_TYPE}
              onDropdownChange={(locationId = '') => {
                this.searchLocationByID(filter, locationId)
              }}
              handleDropDownTrigger={handleDropDownTrigger}
              handleTriggerProps={handleTriggerProps}
              handleTriggerCallback={this.handleTriggerCallback}
              multiLocationSelection
            />
            {!isEmpty(stateFilters['Location-WinterStreet']) && (
              <div className="apply-button-parent">
                <Button
                  id="locationWinterStFilter"
                  className={'add-dept-class-button'}
                  onClick={() => {
                    const updatedFilters =
                      Object.assign({}, filtersCopy, {
                        [filterCompType]: stateFilters,
                      }) || {}
                    setFiltersUpdated(
                      true,
                      updatedFilters,
                      stateSortParam,
                      stateSortOrder
                    )
                  }}
                  disabled={
                    !(
                      Object.keys(stateFilters).indexOf(
                        'Location-WinterStreet'
                      ) !== -1 &&
                      !isEmpty(
                        stateFilters['Location-WinterStreet']['textFieldValue']
                      )
                    )
                  }
                >
                  APPLY
                </Button>
              </div>
            )}
          </Suspense>
        </div>
      )
    } else if (booleanInputs.includes(filter)) {
      return (
        <Form.Field
          type="radio"
          label={filter}
          onUpdate={(id, value) => {
            if (value === 'true') {
              this.getBundled(value, 'bundled', filter)
            } else {
              this.getBundled(value, 'not bundled', filter)
            }
          }}
          options={[
            { value: 'true', label: 'True' },
            { value: 'false', label: 'False' },
          ]}
        />
      )
    } else {
      const {
        selectData: currFilterSelectData = [],
        chipArray: currFilterChipArray = [],
      } = currentFilterList
      this.state.savedData && this.handleMultiSelectChange(filter)
      if (autocompleteSelectDataCopy[filter] && isEmpty(currFilterSelectData)) {
        const stateFiltersCopy = Object.assign({}, stateFilters)
        stateFiltersCopy[filter].selectData = autocompleteSelectDataCopy[filter]
        stateFiltersCopy[filter].chipArray = this.getChipArray(
          cloneDeep(stateFiltersCopy[filter].chipArray),
          autocompleteSelectDataCopy[filter]
        )
        const updateStateFilters = Object.assign({}, currentFilters, {
          [filterCompType]: stateFiltersCopy,
        })
        this.setState({ filters: updateStateFilters })
      } else if (
        isEmpty(currFilterSelectData) &&
        !listInputs.includes(filter)
      ) {
        ;(async () => {
          try {
            const selectData = await this.fetchAutocompleteData(filter)
            if (selectData) {
              const stateFiltersCopy = Object.assign({}, stateFilters)
              stateFiltersCopy[filter].selectData = selectData
              stateFiltersCopy[filter].chipArray = this.getChipArray(
                cloneDeep(stateFiltersCopy[filter].chipArray),
                selectData
              )
              const updateStateFilters = Object.assign({}, currentFilters, {
                [filterCompType]: stateFiltersCopy,
              })
              this.setState({ filters: updateStateFilters })
            }
          } catch (error) {
            console.error('Error fetching autocomplete data:', error)
          }
        })()
      }
      const components = { MultiValue }
      return (
        <div>
          <Input.Label style={{ fontWeight: 600 }}>{filter}</Input.Label>
          <ReactSelect
            classes={classes}
            styles={{
              input: (base) => ({
                ...base,
                height: '48px',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }),
            }}
            inputId="react-select-dept"
            TextFieldProps={{
              label:
                (filterCompType === 'exclude_filters' ? 'Exclude' : 'Add ') +
                filter,
              InputLabelProps: {
                htmlFor: 'react-select-dept',
                shrink: true,
              },
            }}
            placeholder={
              (filterCompType === 'exclude_filters' ? 'Exclude' : 'Add ') +
              filter
            }
            options={currFilterSelectData}
            value={currFilterChipArray}
            onChange={this.handleMultiSelectChange(filter)}
            isMulti
            components={components}
          />
        </div>
      )
    }
  }

  handleMultiSelectChange = (filter) => (event) => {
    const { setFiltersUpdated = () => {}, filterCompType = '' } = this.props
    const {
      filters: stateFilters = {},
      sortParam = '',
      sortOrder = '',
    } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter].chipArray = event
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
    setFiltersUpdated(true, updateStateFilters, sortParam, sortOrder)
  }

  handleDateInput = (filter = '', date, startOrEnd = '') => {
    const { filters: stateFilters = {} } = this.state
    const { filterCompType = '' } = this.props
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter][startOrEnd] = date
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
  }

  handleDepartmentChange = async (filter, value) => {
    const { filters: stateFilters = {} } = this.state
    const { filterCompType = '' } = this.props
    value = '' + value
    this.selectRef.current?.clearValue()

    if (!/^[0-9]{0,3}$/.test(value)) {
      return
    }
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filter === 'Dept-Class'
      ? (filtersCopy[filter].currentDeptValue = value)
      : (filtersCopy[filter].currentCategoryValue = value)
    filter === 'Dept-Class'
      ? (filtersCopy[filter].currentClassValue = '')
      : (filtersCopy[filter].currentSubCategoryValue = '')
    await this.fetchAutocompleteData(filter, value).then((selectData) => {
      filtersCopy[filter].classSelectData = selectData
    })
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
  }

  handleClassChange = (filter, selectedOption) => {
    const { filterCompType = '' } = this.props
    var valueArray = Array.isArray(selectedOption)
      ? selectedOption.map((x) => x.value)
      : []
    var value = []
    for (let index in valueArray) {
      if (filter === 'Dept-Class' && !/^[0-9]{0,2}$/.test(valueArray[index])) {
        return
      }
      value = valueArray + ',' + valueArray[index]
    }
    const { filters: stateFilters = {} } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filter === 'Dept-Class'
      ? (filtersCopy[filter].currentClassValue = value)
      : (filtersCopy[filter].currentSubCategoryValue = value)
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
  }

  handleTextFieldChange = (filter) => (event) => {
    const { filterCompType = '' } = this.props
    const { filters: stateFilters = {} } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter]['textFieldValue'] = event.target.value
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
  }

  handleDeleteChip =
    (filter, chipData, index, arrayName, deletetype = 'single') =>
    (event) => {
      const { setFiltersUpdated = () => {}, filterCompType = '' } = this.props
      const {
        filters: stateFilters = {},
        sortParam: stateSortParam = '',
        sortOrder: stateSortOrder = '',
      } = this.state
      const stateFiltersCopy = Object.assign({}, stateFilters)
      let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
      let chipArray = []
      if (deletetype === 'all') {
        filtersCopy[filter][arrayName] = chipArray
        filtersCopy[filter]['unrecognizedValues'] = []
        this.setState({ sortParam: '', sortOrder: '' })
      } else {
        chipArray = filtersCopy[filter][arrayName]
        chipArray.splice(index, 1)
      }
      const updateStateFilters = Object.assign({}, stateFilters, {
        [filterCompType]: filtersCopy,
      })
      this.setState({ filters: updateStateFilters }, () => {
        setFiltersUpdated(
          true,
          updateStateFilters,
          stateSortParam,
          stateSortOrder
        )
      })
    }
  handleAllDeleteChip = () => {
    const { setFiltersUpdated = () => {}, filterCompType = '' } = this.props
    const {
      filters: stateFilters = {},
      sortParam: stateSortParam = '',
      sortOrder: stateSortOrder = '',
    } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    let chipArray = []
    Object.keys(filtersCopy).forEach((data) => {
      filtersCopy[data]['chipArray'] = chipArray
      if (data === 'Dept-Class') {
        filtersCopy[data]['deptClassChipArray'] = []
        filtersCopy[data]['deptChipArray'] = []
      }
      filtersCopy[data]['unrecognizedValues'] = []
    })
    this.setState({ sortParam: '', sortOrder: '' })
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters }, () => {
      setFiltersUpdated(
        true,
        updateStateFilters,
        stateSortParam,
        stateSortOrder
      )
    })
  }

  handleChange = (event) => {
    const currentTargetValue =
      event.target.value || (event.target.dataset || {}).value
    const { filters: stateFilters = {} } = this.state
    const { filterCompType = '' } = this.props
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[currentTargetValue] = {}
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({
      filters: updateStateFilters,
      selectIsOpen: false,
    })
  }

  getAllOtherFilters = (filterList = []) => {
    const { filters: stateFilters = {} } = this.state
    const { filterCompType = '' } = this.props
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filterList.forEach((filter) => {
      filtersCopy[filter] = {}
    })

    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({
      filters: updateStateFilters,
      selectIsOpen: false,
    })
  }

  handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      this.setState({ selectIsOpen: false })
    }
  }

  handleSelectChange = (value) => {
    const currentTargetValue = value
    const { filters: stateFilters = {}, inputTypeFilters } = this.state
    const { filterCompType = '' } = this.props
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[currentTargetValue] = {}
    const inputTypeFilterCopy = Object.assign(
      {},
      inputTypeFilters[filterCompType]
    )
    inputTypeFilterCopy['filterSelect'] = currentTargetValue
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    const updateinputTypeFilters = Object.assign({}, inputTypeFilters, {
      [filterCompType]: inputTypeFilterCopy,
    })
    this.setState({
      filters: updateStateFilters,
      inputTypeFilters: updateinputTypeFilters,
    })
  }

  processChips = (inputString, filter) => {
    const {
      setFiltersUpdated = () => {},
      fetchLocationDetails = () => {},
      filterCompType = '',
    } = this.props
    let splitInputArray = []
    let returnArray = []
    let unrecognizedValuesArray = []

    if (
      listInputs.indexOf(filter) !== -1 &&
      inputString.split(/[,\r\n\s,]+/g).length > 1 && ['']
    ) {
      inputString.trim()
      if (nameBasedListInputs.indexOf(filter) !== -1) {
        splitInputArray = inputString.split(/[,\r\n]+/g)
      } else {
        splitInputArray = inputString.split(/[,\r\n\s]+/g)
      }
    } else if (inputString.split('\n').length > 1) {
      inputString.trim()
      splitInputArray = inputString.split('\n')
    } else if (inputString.split(',').length > 0) {
      inputString.trim()
      if (inputString.charAt(inputString.length - 1) === ',') {
        inputString = inputString.substring(0, inputString.length - 1)
      }
      splitInputArray = inputString.split(',')
    } else {
      splitInputArray = inputString.trim()
    }

    splitInputArray = [...new Set(splitInputArray)]

    for (let index in splitInputArray) {
      let localFilter =
        ['Prop ID', 'Scenic Filemaker ID', 'Filemaker ID'].indexOf(filter) !==
        -1
          ? 'Filemaker ID'
          : filter
      if (regexExpressions[localFilter].test(splitInputArray[index].trim())) {
        if (
          [
            'Ordered By',
            'Project/Collection Creator',
            'Shipment Creator',
            'Scenic Created By',
          ].indexOf(filter) !== -1 &&
          splitInputArray[index].trim().split(' ').length > 1
        ) {
          returnArray.push(splitInputArray[index].trim().split(' ').join('.'))
        } else {
          returnArray.push(splitInputArray[index].trim())
        }
      } else if (splitInputArray[index].trim() !== '') {
        unrecognizedValuesArray.push(splitInputArray[index].trim())
      }
    }
    const {
      filters: stateFilters = {},
      sortParam: stateSortParam = '',
      sortOrder: stateSortOrder = '',
    } = this.state
    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    if (Object.entries(filtersCopy).length > 0) {
      Object.values(filtersCopy).map((obj = []) => {
        if (!isEmpty(obj) && typeof obj !== 'string') {
          obj['islatest'] = false
        }
        return obj
      })
    }
    if (filtersCopy[filter].chipArray) {
      returnArray = filtersCopy[filter].chipArray.concat(returnArray)
      returnArray = [...new Set(returnArray)]
    }

    filtersCopy[filter].chipArray = returnArray
    filtersCopy[filter].unrecognizedValues = unrecognizedValuesArray
    filtersCopy[filter].textFieldValue = ''
    filtersCopy[filter].islatest = true
    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
    setFiltersUpdated(true, updateStateFilters, stateSortParam, stateSortOrder)
    if (!isEmpty(returnArray) && filter === 'Location ID') {
      let params = new URLSearchParams()
      params.append('key', apiConfig.apiKey)
      params.append('location_ids', returnArray)
      fetchLocationDetails(params, () => {
        this.setState({
          isFetchedlocation: true,
        })
      })
    }
  }

  processDeptClassChips = (deptString, classString, filter) => {
    const {
      filters: stateFilters = {},
      sortParam: stateSortParam = '',
      sortOrder: stateSortOrder = '',
    } = this.state
    const { setFiltersUpdated = () => {}, filterCompType = '' } = this.props
    const departmentID = this.addLeadingZeros(deptString, 3)
    const splitInputArray =
      typeof classString === 'string' && classString.split(',')

    const stateFiltersCopy = Object.assign({}, stateFilters)
    let filtersCopy = Object.assign({}, stateFiltersCopy[filterCompType])
    filtersCopy[filter].currentCategoryValue = ''
    filtersCopy[filter].currentSubCategoryValue = ''

    filtersCopy[filter].currentDeptValue = ''
    filtersCopy[filter].currentClassValue = ''
    if (!classString) {
      if (filter === 'Dept-Class' && !filtersCopy[filter].deptChipArray) {
        filtersCopy[filter].deptChipArray = [departmentID]
      } else if (
        filter !== 'Dept-Class' &&
        !filtersCopy[filter].categoryChipArray
      ) {
        filtersCopy[filter].categoryChipArray = [departmentID]
      } else if (
        filter === 'Dept-Class' &&
        filtersCopy[filter].deptChipArray &&
        !filtersCopy[filter].deptChipArray.includes(departmentID)
      ) {
        filtersCopy[filter].deptChipArray.push(departmentID)
      } else if (
        filter !== 'Dept-Class' &&
        filtersCopy[filter].categoryChipArray &&
        !filtersCopy[filter].categoryChipArray.includes(departmentID)
      ) {
        filtersCopy[filter].categoryChipArray.push(departmentID)
      }
    } else {
      for (let index in splitInputArray) {
        var classID = this.addLeadingZeros(splitInputArray[index], 2)

        if (
          filter === 'Dept-Class' &&
          !filtersCopy[filter].deptClassChipArray
        ) {
          filtersCopy[filter].deptClassChipArray = [
            departmentID + '-' + classID,
          ]
        } else if (
          filter !== 'Dept-Class' &&
          !filtersCopy[filter].categorySubCategoryArray
        ) {
          filtersCopy[filter].categorySubCategoryArray = [
            departmentID + '-' + classID,
          ]
        } else if (
          filter === 'Dept-Class' &&
          filtersCopy[filter].deptClassChipArray &&
          !filtersCopy[filter].deptClassChipArray.includes(
            departmentID + '-' + classID
          )
        ) {
          filtersCopy[filter].deptClassChipArray.push(
            departmentID + '-' + classID
          )
        } else if (
          filter !== 'Dept-Class' &&
          filtersCopy[filter].categorySubCategoryArray &&
          !filtersCopy[filter].categorySubCategoryArray.includes(
            departmentID + '-' + classID
          )
        ) {
          filtersCopy[filter].categorySubCategoryArray.push(
            departmentID + '-' + classID
          )
        }
      }
    }

    const updateStateFilters = Object.assign({}, stateFilters, {
      [filterCompType]: filtersCopy,
    })
    this.setState({ filters: updateStateFilters })
    setFiltersUpdated(true, updateStateFilters, stateSortParam, stateSortOrder)
  }

  addLeadingZeros = (stringToAddZero = '', intendedStringLength) => {
    if (!stringToAddZero) {
      return
    }
    let returnString = stringToAddZero
    while (returnString.length < intendedStringLength) {
      returnString = '0' + returnString
    }
    return returnString
  }

  handleCheckBoxChange = (event) => {
    const item = event.target.name
    const isChecked = event.target.checked
    var checkedParam = ''
    var sortOrderParam = ''
    if (isChecked) {
      checkedParam = item.split(' ').join('_')
      sortOrderParam = 'INPUT'
    }
    this.setState((state) => ({
      ...state,
      sortParam: checkedParam,
      sortOrder: sortOrderParam,
    }))
  }
  handleFilterClick(filter = '', id = '') {
    const { availableFilters = [] } = this.props
    for (let index in availableFilters) {
      const { title: saveFilterTitle = '', filters: savedFilters = [] } =
        availableFilters[index]
      if (saveFilterTitle === filter) {
        this.setFiltersData(savedFilters)
        this.handleChooseFilters(savedFilters)
        this.setState({
          selectedFilter: true,
          filterTitle: filter,
          filterId: id,
        })
      }
    }
  }

  deleteFilters = (filterId = '') => {
    const { deleteFilters = () => {}, pageName = '' } = this.props
    deleteFilters(filterId, pageName)
  }

  handleDeleteFilterClick = (selectedFilter = {}) => {
    const { id: filterId = '', title: filterName = '' } = selectedFilter
    const message = `${
      'You have selected "' + filterName + '" filter to delete?'
    }`
    this.setState({
      showAlertOnDelete: true,
      alertMessageOnDelete: message,
      deleteFilterId: filterId,
      deleteResponse: true,
    })
  }

  closeAlert = (e) => {
    this.setState({
      showAlertOnDelete: false,
      alertMessageOnDelete: '',
      deleteResponse: false,
      deleteFilterId: '',
    })
  }

  onDeleteFilter = () => {
    const { deleteFilterId = '' } = this.state
    const { deleteFilters = () => {}, pageName = '' } = this.props
    this.setState(
      {
        showAlertOnDelete: false,
        alertMessageOnDelete: '',
        deleteFilterId: '',
        deleteResponse: false,
      },
      () => {
        deleteFilters(deleteFilterId, pageName)
      }
    )
  }
  render() {
    const {
      classes = {},
      setFiltersUpdated = () => {},
      filterCompType = '',
      displayFiltersTitle = false,
    } = this.props
    const selectableFiltersList = this.getSelectableFilters()
    const listInputFilters = this.getListInputSelectableFilters()
    const {
      filters: filtersCopy = {},
      selectIsOpen = false,
      saveFiltersPopUpIsVisible = false,
      sortParam: stateSortParam = '',
      sortOrder: stateSortOrder = '',
      showAlertOnDelete = false,
      alertMessageOnDelete = '',
      deleteResponse = false,
      moreFiltersDialog = false,
      moreFiltersSelectedDialog = '',
      inputTypeFilters = {},
    } = this.state
    const stateFilters = Object.assign({}, filtersCopy)
    const compTypeFilters = stateFilters[filterCompType] || {}
    const dropDownOptions = listInputFilters.map((dat) => {
      return { value: dat, label: dat }
    })
    const filterSelect = inputTypeFilters[filterCompType]['filterSelect']
    const stateFiltersList = Object.keys(compTypeFilters)
    const isFilterExistsInState =
      stateFiltersList.length > 0 &&
      stateFiltersList.indexOf(filterSelect) !== -1
    const currentFilterList = isFilterExistsInState
      ? compTypeFilters[filterSelect]
      : {}

    const { textFieldValue = '', unrecognizedValues = [] } = currentFilterList
    return (
      <div className={`${classes.root} filter-section`}>
        <div className={classes.toolBar}>
          <div className={classes.spacer} />
          {/* {this.renderSavedFilters()} */}
        </div>
        <Card elevation={3} className="filter-card">
          <Grid.Container className="filter-search-grid" spacing="none">
            {!isEmpty(listInputFilters) ? (
              <Grid.Item
                xs={12}
                md={9}
                lg={9}
                className="filter-search-grid-item"
              >
                <Input.Select
                  className="search-select"
                  value={filterSelect}
                  defaultValue={''}
                  onUpdate={(_, value) => {
                    this.handleSelectChange(value)
                  }}
                  options={[
                    { value: '', label: 'Select', disabled: true },
                    ...dropDownOptions,
                  ]}
                  placeholder="Select"
                />
                <Input.Text
                  value={textFieldValue}
                  className="input-search"
                  placeholder={`Enter ${textFieldValue}`}
                  onChange={this.handleTextFieldChange(filterSelect)}
                  disabled={!filterSelect}
                />
                <Button
                  onClick={() => {
                    const updateStateFilters = Object.assign({}, filtersCopy, {
                      [filterCompType]: stateFilters,
                    })
                    setFiltersUpdated(
                      true,
                      updateStateFilters,
                      stateSortParam,
                      stateSortOrder
                    )
                    this.processChips(textFieldValue, filterSelect)
                  }}
                  disabled={!textFieldValue}
                  className="search-button"
                >
                  <EnterpriseIcon icon={SearchIcon} />
                </Button>
              </Grid.Item>
            ) : (
              <></>
            )}
            {!isEmpty(selectableFiltersList) ? (
              <Grid.Item
                xs={12}
                md={3}
                lg={3}
                className="filter-search-grid-item"
              >
                <Button
                  type="primary"
                  onClick={() => {
                    isEmpty(stateFiltersList) &&
                      this.getAllOtherFilters(selectableFiltersList)
                    this.setState({ moreFiltersDialog: true })
                  }}
                  className="more-filters-button"
                >
                  More Filters
                </Button>
              </Grid.Item>
            ) : (
              <></>
            )}
            <Grid.Item xs={12} md={12} lg={12}>
              <div style={{ display: 'flex' }}>{this.getAllFilterChips()}</div>
            </Grid.Item>
          </Grid.Container>
        </Card>
        {saveFiltersPopUpIsVisible && (
          <NameFiltersPopUp
            isVisible={saveFiltersPopUpIsVisible}
            onClose={this.closeWithoutSaving}
            saveFilters={this.handleSaveFilters}
            title={this.state.filterTitle}
          />
        )}
        <DialogBox
          isAlertVisible={showAlertOnDelete}
          message={alertMessageOnDelete}
          onClose={this.closeAlert}
          response={deleteResponse}
          onAgree={this.onDeleteFilter}
          title="Delete Filter?"
          primaryButtonText="YES, DELETE FILTER"
          secondaryButtonText="NEVERMIND"
          fullWidth
        />
        <Drawer
          isVisible={moreFiltersDialog}
          headingText={`${filterCompType === 'exclude_filters' ? 'Exclude' : 'Add '} More Filters`}
          onRequestClose={() => this.setState({ moreFiltersDialog: false })}
          xs={12}
          md={12}
          lg={3}
          className="more-filters-drawer"
        >
          <div
            className="more-filters-drawer-body buttonsDrawer"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            {selectableFiltersList.map((filter) => {
              return (
                <Button
                  onClick={() =>
                    this.setState({ moreFiltersSelectedDialog: filter })
                  }
                >
                  <div>{filter}</div>
                  <div>
                    <EnterpriseIcon icon={ChevronRightIcon} />
                  </div>
                </Button>
              )
            })}
          </div>
        </Drawer>
        <Drawer
          isVisible={moreFiltersSelectedDialog}
          headingText={`${filterCompType === 'exclude_filters' ? 'Exclude' : 'Add '}${moreFiltersSelectedDialog}`}
          onRequestClose={() =>
            this.setState({ moreFiltersSelectedDialog: '' })
          }
          xs={12}
          md={12}
          lg={3}
          className="more-filters-drawer"
        >
          <div className="more-filters-drawer-body">
            {moreFiltersSelectedDialog &&
              this.getInputMethod(moreFiltersSelectedDialog)}
          </div>
        </Drawer>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const { pageName = '' } = ownProps

  return {
    availableFilters: selectPageAvailableFilters(pageName)(state),
    filters: selectPageFilters(pageName)(state),
    channels: getStoreChannels()(state),
    userLocation: state.user.location,
    locations: getLocationDetails()(state),
    saveFiltersData: state.addFilters.saveFiltersData,
    getFiltersPending: state.addFilters.getFiltersPending,
    fetchDataRequestPending: state.searchInventory.fetchDataRequestPending,
    pageName: pageName,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getFilters: (pageName, additionalParams) =>
      dispatch(getFilters(pageName, additionalParams)),
    saveFilters: (filterRequest, filterCopy, pageName) =>
      dispatch(saveFilters(filterRequest, filterCopy, pageName)),
    setFilters: (filters, pageName) => dispatch(setFilters(filters, pageName)),
    deleteFilters: (filterId = '', pageName = '') =>
      dispatch(deleteFilters(filterId, pageName)),
    getProjectChannel: () => dispatch(getProjectChannel()),
    filterLocations: (params) => dispatch(filterLocations(params)),
    saveFilterData: (params) => dispatch(saveFilterData(params)),
    fetchLocationDetails: (params, successCallback = () => {}) =>
      dispatch(fetchLocationDetails(params, successCallback)),
    getDropdownData: (selectedTab = PROPS) =>
      dispatch(getDropdownData(selectedTab)),
  }
}

AddFiltersCanvas.propTypes = {
  availableFilters: propTypes.array,
  selectableFilters: propTypes.array,
  filterCompType: propTypes.string,
  renderFilterIcons: propTypes.bool,
  fromSearch: propTypes.bool,
}

export default withHOCs({
  auth: true,
  nav: true,
  styles,
  connectParams: {
    mapStateToProps,
    mapDispatchToProps,
  },
})(AddFiltersCanvas)
